module.exports = __webpack_public_path__ + "static/media/ideapost-icon.13a1c50a.png";